import { render } from "./CertificateValidate.vue?vue&type=template&id=d389090a&lang=true"
import script from "./CertificateValidate.vue?vue&type=script&lang=js"
export * from "./CertificateValidate.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/certificates-staging.paginasingeniosas.com/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__